import { InputSwitch } from 'primereact/inputswitch'
import React, { useCallback, useEffect } from 'react'
import * as myconst from "../../constants/index"
import { Controller, useFormContext } from 'react-hook-form'
import { RadioButton } from 'primereact/radiobutton';
import { toast } from 'react-toastify';

interface arr_type {
  value: string;
  label: string;
}

const StepEight = ({ handlePrev, goOnFirst, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const finalError = Object.keys(errors).length

  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])

  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Are you open to using AI tools to help with editing, writing, and analytics?</label>
                <Controller
                  name="ai_tools_openness"
                  control={methods.control}
                  rules={{ required: "Please select an option" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('ai_tools_openness').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'ai_tools_openness'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('ai_tools_openness') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('ai_tools_openness') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("ai_tools_openness")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Would you like help with automating workflows to save time?</label>
                <Controller
                  name="workflow_automation"
                  control={methods.control}
                  rules={{ required: "Please select an option" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('workflow_automation').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'workflow_automation'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('workflow_automation') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('workflow_automation') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("workflow_automation")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Do you want SEO and algorithm strategies to boost reach?</label>
                <Controller
                  name="seo_algorithms"
                  control={methods.control}
                  rules={{ required: "Please select an option" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('seo_algorithms').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'seo_algorithms'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('seo_algorithms') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('seo_algorithms') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("seo_algorithms")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                {/* {finalError.length > 0 ?
                  <button type="button" onClick={stepWhichAreIncomplete} className="outline-active-btn" >Submit</button>
                  : */}
                <button type="submit" className="outline-active-btn" >Submit</button>
                {/* } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepEight